module.exports = __webpack_public_path__ + "img/store_web_brown.441b36c4.svg";